var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useFeatureGates } from '@office-start/feature-gates-service';
import React, { useMemo } from 'react';
import { LazyComponentErrorBoundary } from './LazyComponentErrorBoundary';
export var withLazyFeatureGateErrorBoundary = function (LazyComponent, componentName, lazyFeatureOptions) {
    var WrappedLazyComponent = function (props) {
        var _a, _b;
        var featureGates = (_b = (_a = useFeatureGates()) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result;
        var lazyFeatureProps = useMemo(function () { return (__assign(__assign({}, lazyFeatureOptions), { disabled: lazyFeatureOptions.disabledFeatureGateSelector(featureGates) })); }, [featureGates]);
        return (React.createElement(LazyComponentErrorBoundary, { componentName: componentName, lazyFeatureProps: lazyFeatureProps },
            React.createElement(LazyComponent, __assign({}, props))));
    };
    WrappedLazyComponent.displayName = componentName;
    return WrappedLazyComponent;
};
//# sourceMappingURL=withLazyFeatureGateErrorBoundary.js.map